export default {
  nav_spreadsheet: "Tabelle",
  nav_categories: "Kategorien",
  nav_guides: "Leitfäden",
  nav_reviews: "Bewertungen",
  nav_shipping: "Versand",
  nav_safety: "Sicherheit",
  nav_language: "Sprache",

  hero_eyebrow: "DIE ALLCHINABUY SPREADSHEET RESSOURCENHUB",
  hero_title: "AllChinaBuy Spreadsheet — Produkte, Links & Kaufhandbücher Finden",
  hero_subtitle: "Entdecken Sie organisierte AllChinaBuy Spreadsheet-Ressourcen, Produktlinks, Kaufhandbücher, QC-Tipps, Versandinformationen und hilfreiche Tools — alles an einem Ort.",
  hero_cta_primary: "AllChinaBuy Spreadsheet Erkunden",
  hero_cta_secondary: "Beliebte Kategorien Durchsuchen",
  hero_trust: "Unabhängige Ressource • Regelmäßig aktualisiert • Sicherheitsorientiert",

  categories_title: "Nach Kategorie Einkaufen",
  categories_description: "Durchsuchen Sie unsere kuratierten Kategorien und finden Sie genau das, was Sie brauchen",
  categories_button: "Alle Kategorien",

  cta_spreadsheet: "AllChinaBuy Spreadsheet",
  cta_buy_now: "Jetzt Kaufen",
  cta_explore: "Produkte Erkunden",

  value_title: "Alles Was Sie Brauchen, um AllChinaBuy zu Navigieren",
  value_spreadsheet: "Spreadsheet-Ressourcen",
  value_spreadsheet_desc: "Finden Sie organisierte Spreadsheet-Ressourcen und Produktreferenzen.",
  value_discovery: "Produktentdeckung",
  value_discovery_desc: "Erkunden Sie beliebte Kategorien und entdecken Sie nützliche Produktinformationen.",
  value_qc: "QC-Handbücher",
  value_qc_desc: "Lernen Sie, wie Sie Qualitätskontrollfotos und Produktdetails bewerten.",
  value_shipping: "Versandhandbücher",
  value_shipping_desc: "Verstehen Sie Versandoptionen, Kosten, Tracking und wichtige Überlegungen.",
  value_safety: "Sicherheitszentrum",
  value_safety_desc: "Lernen Sie, wie Sie häufige Kauf-, Zahlungs- und Verkäuferrisiken reduzieren.",
  value_comparison: "Vergleichshandbücher",
  value_comparison_desc: "Vergleichen Sie Kaufplattformen, Funktionen und Benutzerüberlegungen.",

  popular_title: "Beliebte AllChinaBuy Spreadsheet Kategorien",
  popular_desc: "Erkunden Sie unsere meistbesuchten Produktkategorien und entdecken Sie Trendartikel",

  how_title: "So Verwenden Sie ein AllChinaBuy Spreadsheet",
  how_step1_title: "Wählen Sie eine Kategorie",
  how_step1_desc: "Durchsuchen Sie Produkte nach Kategorie und Absicht.",
  how_step2_title: "Produktinformationen Überprüfen",
  how_step2_desc: "Überprüfen Sie verfügbare Informationen, Referenzen und QC-Überlegungen.",
  how_step3_title: "Optionen Vergleichen",
  how_step3_desc: "Verwenden Sie Vergleichstabellen und Handbücher, bevor Sie Entscheidungen treffen.",
  how_step4_title: "Zur Hauptwebsite Weiterleiten",
  how_step4_desc: "Verwenden Sie das relevante CTA, wenn Sie bereit sind fortzufahren.",

  trust_title: "Für Intelligenteres Kauf-Research Gebaut",
  trust_desc: "AllChinaBuySpreadsheet.fit ist eine unabhängige Informationsressource, die entwickelt wurde, um nützliche Spreadsheet-Ressourcen und Kaufinformationen zu organisieren. Wir konzentrieren uns auf Klarheit, praktische Anleitung, Sicherheit und regelmäßig aktualisierte Inhalte.",
  trust_point1: "Unabhängige Ressource",
  trust_point2: "Transparente Information",
  trust_point3: "Sicherheitsorientierte Handbücher",
  trust_point4: "Regelmäßige Inhaltsaktualisierungen",
  trust_point5: "Klare redaktionelle Standards",

  articles_title: "Neueste AllChinaBuy Spreadsheet Handbücher",
  articles_desc: "Lesen Sie unsere ausführlichen Artikel, um ein intelligenterer Käufer zu werden",
  articles_read_more: "Weiterlesen",
  articles_category: "Kategorie",
  articles_read_time: "Lesezeit",

  final_cta_title: "Bereit, das AllChinaBuy Spreadsheet zu Erkunden?",
  final_cta_desc: "Durchsuchen Sie die neuesten Ressourcen, entdecken Sie nützliche Kategorien und lernen Sie, den Kaufprozess mit mehr Vertrauen zu navigieren.",
  final_cta_primary: "AllChinaBuy Spreadsheet Erkunden",
  final_cta_secondary: "Lesen Sie das Einsteigerhandbuch",

  footer_tagline: "Ihre unabhängige Ressource für AllChinaBuy Spreadsheet-Ressourcen und Kaufhandbücher.",
  footer_resources: "Ressourcen",
  footer_spreadsheet: "Spreadsheet Hub",
  footer_categories: "Kategorien",
  footer_guides: "Leitfäden",
  footer_reviews: "Bewertungen",
  footer_legal: "Rechtliches",
  footer_about: "Über Uns",
  footer_privacy: "Datenschutzrichtlinie",
  footer_terms: "Nutzungsbedingungen",
  footer_disclaimer: "Haftungsausschluss",
  footer_contact: "Kontakt",
  footer_email: "Email Uns",
  footer_social: "Folgen Sie Uns",
  footer_copyright: "AllChinaBuySpreadsheet.fit. Alle Rechte vorbehalten.",
  footer_independent: "Dies ist ein unabhängiges Ressourcen-Hub. Wir sind nicht mit AllChinaBuy verbunden.",

  article_back: "Zurück zur Startseite",
  article_updated: "Zuletzt Aktualisiert",
  article_share: "Diesen Artikel Teilen",
  article_related: "Verwandte Artikel",
  article_read_more: "Weiterlesen",
  article_author: "Redaktionsteam",
  article_table_of_contents: "Inhaltsverzeichnis",
  article_jump_to: "Zu Abschnitt Springen",

  safety_title: "Intelligenter Einkaufen Mit Unseren Sicherheitshandbüchern",
  safety_desc: "Bevor Sie einen Produktlink verwenden oder eine Bestellung aufgeben, lernen Sie, wie Sie Verkäufer, Produktinformationen, QC-Fotos, Zahlungsmethoden und Versandrisiken bewerten.",
  safety_cta: "Sicherheitszentrum Besuchen",
  safety_notice: "Überprüfen Sie immer aktuelle Produkt-, Verkäufer-, Zahlungs- und Versandinformationen, bevor Sie bestellen. Details können sich im Laufe der Zeit ändern.",

  comparison_title: "AllChinaBuy & Beliebte Kaufplattformen",
  comparison_note: "Überprüfen Sie aktuelle Informationen, bevor Sie bestellen.",
  comparison_platform: "Plattform",
  comparison_spreadsheet: "Spreadsheet-Ressourcen",
  comparison_qc: "QC",
  comparison_shipping_info: "Versandinformationen",
  comparison_beginner: "Anfängerfreundlich",

  read_guide: "Handbuch Lesen",
  learn_more: "Mehr Erfahren",
  search_placeholder: "Suchen Sie nach AllChinaBuy Spreadsheets, Produkten, Kategorien oder Handbüchern...",
  search_title: "Finden Sie Was Sie Suchen",
  search_suggested: "Vorgeschlagene Suchen",
  featured_spreadsheet: "AllChinaBuy Spreadsheet",
  featured_spreadsheet_desc: "Beginnen Sie mit der wichtigsten Ressource auf dieser Website. Erkunden Sie organisierte Spreadsheet-Informationen, Kategorien, Produktreferenzen und praktische Kaufberatung.",
  explore_spreadsheet: "Spreadsheet Erkunden",
  home_breadcrumb: "Startseite",
  article_breadcrumb: "Artikel",
  scroll_to_top: "Zurück nach oben",
  main_website: "Hauptwebsite",
  visit_main: "Hauptwebsite Besuchen",

  // Products
  products_title: "Alle Produkte aus dem Kakobuy Spreadsheet",
  products_subtitle: "Durchsuchen Sie unsere vollständige Sammlung kuratierter Produkte mit direkten Kauf-Links",
  products_view_all: "Alle {category} ansehen",
  products_buy_now: "Jetzt Kaufen",
  products_from: "Ab",
};